import React,{useLayoutEffect,useRef} from 'react';
import {LINK_SOURCE} from './linkTokens';
// Matches http(s) links, www. links and bare domains with common TLDs.
export const LINK_REGEX=new RegExp('('+LINK_SOURCE+')','i');
export const hasLink=(text:string)=>LINK_REGEX.test(text);
export const linkHref=(part:string)=>/^https?:\/\//i.test(part)?part:'https://'+part;
const COPIED=['fontFamily','fontSize','fontWeight','lineHeight','letterSpacing','paddingTop','paddingRight','paddingBottom','paddingLeft','borderTopWidth','borderRightWidth','borderBottomWidth','borderLeftWidth','boxSizing','textIndent','tabSize'] as const;
// Draws the composer text on top of a transparent-text textarea so links show in blue while typing.
export function LinkMirror({text,target}:{text:string;target:React.RefObject<HTMLTextAreaElement|null>}){
  const mirror=useRef<HTMLDivElement>(null);
  useLayoutEffect(()=>{
    const ta=target.current,m=mirror.current;if(!ta||!m)return;
    const sync=()=>{const cs=getComputedStyle(ta);for(const k of COPIED)(m.style as any)[k]=cs[k];
      m.style.left=ta.offsetLeft+'px';m.style.top=ta.offsetTop+'px';m.style.width=ta.offsetWidth+'px';m.style.height=ta.offsetHeight+'px';m.scrollTop=ta.scrollTop;};
    sync();const ro=new ResizeObserver(sync);ro.observe(ta);ta.addEventListener('scroll',sync);
    return()=>{ro.disconnect();ta.removeEventListener('scroll',sync);};
  },[text,target]);
  const parts=text.split(new RegExp(LINK_REGEX.source,'gi'));
  return <div ref={mirror} className="composer-link-mirror" aria-hidden="true">{parts.map((p,i)=>i%2?<span key={i} className="composer-link">{p}</span>:p)}{text.endsWith('\n')?' ':''}</div>;
}
